<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">자주하는 질문</span>
            <span class="txt">센터 admin에 보여질 자주하는 질문사항과 답변 게시글을 작성 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-setting-btn" @click="categoryPop = true"></button>
                </div>
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/question/list">목록</router-link>
                    <button v-if="id" class="com-btn blue" @click="createQuestion">수정</button>
                    <button v-else class="com-btn blue" @click="createQuestion">등록</button>
                </div>
            </div>
            <table class="com-table edit">
                <colgroup>
                    <col style="width: 150px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td class="no-padding">
                            <select-form
                                :select-data="['카테고리를 선택하세요.', ...categoryTypeList]"
                                :select-value="['', ...categoryTypeValueList]"
                                :selected-value="categoryId"
                                class="full"
                                @update:set="(val) => (categoryId = val)"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td>
                            <input ref="refTitle" v-model="title" class="w100p" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <th>내용</th>
                        <td>
                            <ckeditor v-model="editorData" :config="editorConfig" :editor="editor"></ckeditor>
                        </td>
                    </tr>
                    <tr>
                        <th>파일 첨부</th>
                        <td class="no-padding">
                            <div class="file-box">
                                <input v-model="fileNameListStr" class="design-input" readonly type="text" />
                                <b-form-file
                                    id="file1"
                                    accept=".jpg, .png, .gif"
                                    plain
                                    @change="handleFile"
                                ></b-form-file>
                                <label for="file1">찾아보기</label>
                                <span>&nbsp;&nbsp;파일은 최대 3개까지 첨부 가능합니다. (파일당 5MB 이하)</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="table-bottom-check">
                <div class="com-check">
                    <input id="check-1-1" v-model="topFixYn" name="check-1" type="checkbox" />
                    <label for="check-1-1">이 글을 상단에 고정합니다.</label>
                </div>
            </div>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/question/list">목록</router-link>
                    <button v-if="id" class="com-btn blue" @click="createQuestion">수정</button>
                    <button v-else class="com-btn blue" @click="createQuestion">등록</button>
                </div>
            </div>
        </div>

        <!-- 설정 팝업 -->
        <div v-show="categoryPop" class="layer-pop category-setting">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">카테고리 설정</span>
                    <p class="sub-txt">
                        카테고리의 이름을 추가, 수정 및 삭제 할 수 있습니다.
                        <br />
                        카테고리 삭제 시, 이전에 작성된 해당 카테고리의 게시글은 카테고리가 없이 표시됩니다.
                    </p>
                    <loading-spinner v-if="isLoading"></loading-spinner>
                    <div v-else class="del-box">
                        <div class="input-cnt flex-col">
                            <div
                                v-for="(category, index) in categoryList.infos"
                                v-if="category.deleteYn === false"
                                class="line"
                            >
                                <input :key="index" ref="categoryArray" v-model="category.name" type="text" />
                                <button class="com-btn" @click="deleteCategory(category.id, index)">삭제</button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" @click="addCategory">+추가</button>
                            </div>
                            <p class="txt">
                                <span class="imp">*</span>
                                최대 10개까지 추가 가능합니다.
                            </p>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="onCancle">취소</button>
                        <button class="com-btn blue" @click="saveCategory">저장</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { validateSpace } from '@/assets/js/validation.js';
import ClassicEditor from '@/assets/js/ckeditor/ckeditor.js';
import SimpleUpload from '../../../assets/js/ckeditor/simpleUpload';

export default {
    name: 'questionEdit',
    components: { LoadingSpinner },
    data() {
        return {
            isLoading: false,
            id: this.$route.params.id, // id가 있으면 수정
            categoryPop: false,
            categoryList: {
                infos: [],
            },
            categoryTypeList: [],
            categoryTypeValueList: [],
            editor: ClassicEditor,
            editorData: '',
            editorConfig: {
                extraPlugins: [SimpleUpload],
                height: '500px',
                language: 'ko',
                simpleUpload: {
                    uploadUrl: '/admin/api/board/file',
                    headers: {
                        'X-CSRF-TOKEN': 'CSRF-Token',
                    },
                },
            },
            categoryId: '',
            title: null,
            content: null,
            topFixYn: false,
            uploadFiles: [], // base64, mimetype, name이 담김. 실제로 서버로 request할 data

            base64data: '', // 업로드 파일 base64 임시 저장
            fetchFileList: [], // 수정화면에서 기존에 첨부되어 있던 파일 목록
            fileNameList: [], // 새로 업로드할 파일 목록을 이름으로만 배열로 관리
            fileNameListStr: '', // fileNameList 배열을 화면에 뿌릴때  ', ' 로 연결하기 위해 만든 순수 String
            deleteFileIds: [], // 삭제되는 첨부파일 fileId 배열

            selectedCategoryId: '',
        };
    },
    mounted() {
        this.fetchCategory();
        if (this.id) {
            // 수정이면 자주하는 질문 상세 가져옴
            this.fetchQuestionDetail();
        }
    },
    methods: {
        // 자주하는 질문 등록 API
        postQuestion(data) {
            return api.post('/admin/api/ft/board/faq', data);
        },

        // 자주하는 질문 수정 API
        putQuestion(id, data) {
            return api.put(`/admin/api/ft/board/faq/${id}`, data);
        },

        // 등록, 수정 validation
        validateValues() {
            const domEditableElement = document.querySelector('.ck-editor__editable');
            const editorInstance = domEditableElement.ckeditorInstance;
            this.editorData = editorInstance.getData();

            if (this.title === '' || this.title === null) {
                this.$nextTick(function () {
                    this.$refs.refTitle.focus();
                });
                return '제목을 입력하세요.';
            } else if (this.editorData === '' || this.editorData === null) {
                return '내용을 입력하세요.';
            }
        },

        // 자주하는 질문 등록, 수정
        async createQuestion() {
            const validate = this.validateValues();
            if (validate) {
                alert(validate);
                return;
            }

            const domEditableElement = document.querySelector('.ck-editor__editable');
            const editorInstance = domEditableElement.ckeditorInstance;
            this.editorData = editorInstance.getData();

            this.isLoading = true;
            if (this.id) {
                // 수정
                try {
                    if (this.uploadFiles.length !== 0) {
                        // uploadFiles에 값이 있으면 파일을 수정한것, 기존 파일은 delete 하는것으로 간주
                        this.fetchFileList.forEach((file) => {
                            this.deleteFileIds.push(parseInt(file.fileId));
                        });
                    }
                    console.log('deleteFileIds : ', this.deleteFileIds);
                    const updateData = {
                        categoryId: this.categoryId,
                        title: this.title,
                        content: this.editorData,
                        deleteFileIds: this.deleteFileIds,
                        topFixYn: this.topFixYn,
                        uploadFiles: this.uploadFiles,
                    };

                    if (this.categoryId === '') {
                        delete updateData.categoryId;
                    }

                    console.log('updateData : ', updateData);
                    const { data } = await this.putQuestion(this.id, updateData);
                    alert('수정 되었습니다.');
                    console.log('===> Success Update Question : ', data);
                    this.$router.push({ name: 'questionList' });
                } catch (error) {
                    alert('수정 실패했습니다.');
                    console.log(error);
                }
            } else {
                // 등록
                try {
                    const createData = {
                        categoryId: this.categoryId,
                        title: this.title,
                        content: this.editorData,
                        topFixYn: this.topFixYn,
                        deleteFileIds: this.deleteFileIds,
                        uploadFiles: this.uploadFiles,
                    };

                    if (this.categoryId === '') {
                        delete createData.categoryId;
                    }

                    const { data } = await this.postQuestion(createData);
                    alert('등록 되었습니다.');
                    console.log('===> Success Create Question : ', data);
                    this.$router.push({ name: 'questionList' });
                } catch (error) {
                    alert('등록 실패했습니다.');
                    console.log(error);
                }
            }
            this.isLoading = false;
        },

        // 자주하는 질문 상세 첨부 파일 리스트 API
        getQuestionDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 자주하는 질문 상세 Fetch
        async fetchQuestionDetail() {
            try {
                this.isLoading = true;
                const { data } = await this.getQuestionDetail();
                this.categoryId = String(data.categoryId === null ? '' : data.categoryId);
                this.title = data.title;
                this.topFixYn = data.topFixYn;
                this.editorData = data.content;
                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.getQuestionDetailFileGroup(data.fileGroupId);
                    console.log(fileGroupData);
                    fileGroupData.data.forEach((file) => {
                        this.fileNameList.push(file.name);
                    });
                    this.fileNameListStr = this.fileNameList.join(', ');
                    this.fetchFileList = fileGroupData.data;
                }

                console.log('Success Loading Question Detail', data);
                this.isLoading = false;
            } catch (error) {
                console.log(error.response.data);
            }
        },

        // 자주하는 질문 상세 API
        getQuestionDetail() {
            return api.get(`/admin/api/ft/board/faq/${this.id}`);
        },

        // File 핸들러
        async handleFile(e) {
            try {
                console.log(e);
                const file = e.target.files[0];
                let base64data = await this.readFileAsync(file);
                base64data = base64data.split(',')[1];
                if (base64data === undefined) {
                    alert('비어있는 파일은 첨부할 수 없습니다.');
                    return;
                }
                const fileInfo = {
                    filename: file.name,
                    mimetype: file.type,
                    base64data,
                };

                if (this.id) {
                    if (this.uploadFiles.length === 0) {
                        this.fileNameList = [];
                        this.fileNameList.push(fileInfo.filename);
                        this.fileNameListStr = this.fileNameList.join(', ');
                    } else {
                        this.fileNameList.push(fileInfo.filename);
                        this.fileNameListStr = this.fileNameList.join(', ');
                    }
                } else {
                    this.fileNameList.push(fileInfo.filename);
                    this.fileNameListStr = this.fileNameList.join(', ');
                }
                this.uploadFiles.push(fileInfo);
            } catch (error) {
                console.log(error);
                alert('파일 첨부 중 오류가 발생했습니다.');
            }
        },

        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        // 카테고리 가져오기
        async fetchCategory() {
            try {
                this.isLoading = true;
                const { data } = await this.getCategoryList();
                console.log('===> Success Loading categoryList : ', data);
                data.forEach((category) => {
                    // 받아온 data의 key 값을 필요한 값으로만 재배열
                    const tempCategory = {
                        id: category.b_id,
                        largeType: category.b_l_type_cd,
                        smallType: category.b_s_type_cd,
                        name: category.b_namee,
                        deleteYn: category.b_del_yn,
                    };
                    this.categoryList.infos.push(tempCategory);
                });
                this.categoryList.infos.forEach((category) => {
                    // 카테고리 리스트를 select-form 카테고리 목록에 push
                    this.categoryTypeList.push(category.name);
                    this.categoryTypeValueList.push(String(category.id));
                });
                this.isLoading = false;
            } catch (error) {
                console.log(error);
            }
        },

        // 카테고리 목록 조회 API
        getCategoryList() {
            return api.get('/admin/api/board/category', {
                params: {
                    largeType: 'F', // 케어어드민 : F, 센터어드민 : C
                    smallType: 'F', // 팝업 : P, 게시판 : B, 자주하는질문 : F, 일대일문의 : I, 메뉴얼 : M
                },
            });
        },

        // 카테고리 아이템 추가
        addCategory() {
            if (this.categoryList.infos.length > 10) {
                alert('카테고리는 최대 10개까지만 추가 가능합니다.');
                return;
            }
            this.categoryList.infos.push({
                largeType: 'F',
                smallType: 'F',
                name: '',
                deleteYn: false,
            });
        },

        // 카테고리 아이템 삭제
        deleteCategory(categoryId, index) {
            console.log(categoryId, index);
            if (categoryId === undefined) {
                this.categoryList.infos.splice(index, 1);
            } else if (categoryId) {
                this.categoryList.infos[index].deleteYn = !this.categoryList.infos[index].deleteYn;
            }
        },

        // 카테고리 저장 API
        postSaveCatetory() {
            return api.post('/admin/api/board/category', this.categoryList);
        },

        // 카테고리 저장
        async saveCategory() {
            const validate = this.validateCategoryValues();
            if (!validate.result) {
                alert(validate.msg);
                this.$nextTick(function () {
                    this.$refs.categoryArray[validate.resultIndex].focus();
                });
                return;
            }
            try {
                const { data } = await this.postSaveCatetory();
                console.log('===> Success Category create : ', data);
                alert('카테고리를 저장했습니다.');
                this.initCategoryValue();
                await this.fetchCategory();
            } catch (error) {
                alert('카테고리 저장 실패했습니다.');
                console.log(error);
            }
        },

        // 카테고리 validation
        validateCategoryValues() {
            const msg = '카테고리명을 다시 확인하세요.';
            let result = true;
            let resultIndex = '';
            this.$refs.categoryArray.some((category, index) => {
                if (!validateSpace(category.value) || category.value.length < 2) {
                    result = false;
                    resultIndex = index;
                    return true;
                }
            });
            return { result, resultIndex, msg };
        },

        // 취소 버튼 클릭 이벤트
        onCancle() {
            this.initCategoryValue();
            this.fetchCategory();
            this.categoryId = this.selectedCategoryId;
        },

        // 카테고리 저장전 관련 변수 초기화
        initCategoryValue() {
            this.categoryPop = false;
            this.categoryList = { infos: [] };
            this.categoryTypeList = [];
            this.categoryTypeValueList = [];
            this.selectedCategoryId = this.categoryId; // 이전에 선택했던 카테고리 임시 저장
        },

        // a 태그 파일 다운로드 이벤트
        fileDownload(url) {
            api.post(url, {
                responseType: 'blob',
            })
                .then((response) => {
                    const blob = new Blob([response.data], { type: 'image/png' });

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ');
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
<style lang="scss">
.ui-select.full.on {
    // ckeditor가 select-form보다 위에 나타나는 이슈
    z-index: 10;
}

.ck-editor__editable {
    min-height: 500px;
}

a.file-down::after {
    content: ',' attr(file-down);
    margin-right: 5px;
}

a.file-down:last-of-type::after {
    content: '';
}

.layer-pop.notice-pop .view-content .view-area .text-box {
    font-size: 15px;
    line-height: 20px;
    padding: 0;
    text-align: left;
}
</style>
